import React from 'react'
import { Link, LinkProps, useLocation } from 'react-router-dom'
import { PartialPath } from 'history'

// This offers an alternative to the Link component from react-router-dom
// that preserves the query string parameters from the current URL.
export const PreservingLink = (props: LinkProps) => {
    const location = useLocation()

    // Extract the passed "to" prop into a PartialPath object.
    let partial: PartialPath
    if (typeof props.to == 'string') {
        const url = new URL(props.to, window.location.origin)
        partial = {
            pathname: url.pathname,
            search: url.search,
            hash: url.hash,
        }
    } else {
        partial = props.to
    }

    // Pull the query string parameters from the current URL.
    const searchParams = new URLSearchParams(location.search)

    // And merge in the new values query string parameters, overwriting any existing
    for (const [key, value] of Object.entries(new URLSearchParams(partial.search))) {
        searchParams.set(key, value)
    }

    // Finally, update the partial object with the new query string parameters.
    partial.search = '?' + searchParams.toString()

    return <Link {...props} to={partial} />
}
